import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { t } from "i18next";

import {
  selectReplies,
  addNewMessage,
  removeLoadingMsgs,
  removeAndAddMessages,
  setReplies,
  setOptionsTypeLogs,
  selectOptionsTypeLogs,
  getAppSSID,
  selectPropertyId,
  setLabelItems,
  selectLabelItems,
  getConversationID,
  selectIsJAI,
  setIsDisabled,
  selectIsDisabled,
  getIsMaximized,
  updateFaq,
  filterEditMessages,
  getVisibleVideos,
  getVisiblePhotos,
  getVisibleCommunityInfo,
  setPagination,
  getAMAReply,
  setAMAReply,
  resetLabelItems,
  resetScheduleTourState,
  selectMessages,
  getOrgId,
  selectAPIKey,
  getEntryId,
  getEnabledScheduleTour,
} from "slices";
import {
  getNextOptions,
  makeNextOptions,
  createItemRecord,
  initialKeyOptions,
  saveConversationFeedback,
  feedbackKeyOptions,
  optionTypes,
  compMsgKeys,
  formatMessageEdit,
  defaultEditFormats,
  EXPLORE_MORE_OPTION,
  isFirstCall,
  ALL_CHAT_SUBJECTS,
  optionsBySubject,
} from "utils";
import {
  APPOINTMENT_TYPES,
  CANCEL_FORM_KEYS,
  DEFAULT_SESSION_ID,
  ERROR_MSG,
  FORM_4_CONTACT_US_OPTIONS,
  INITIAL_REPLIES,
  SCHEDULE_TOUR_INQUIRIES,
} from "utils/constants/index";
import { setTourAction } from "slices/schedule-tour-slice/index";
import { getVisibleInPersonTour, getVisibleLiveVideoTour, getVisibleSelfGuidedTour } from "slices/property-slice/index";
import {
  getFAQsReply,
  getLastConversations,
  createHayleyMessage,
  handleTourResponse,
  getLocalStorageContextDetails,
  getSubjectFromNextOptionType,
} from "utils/methods/index";
import { setShouldFetchSlots } from "slices/param-slice/index";

import BoxView from "./BoxView";
import InputView from "./InputView";
import MultiInputView from "./MultiInputView";

const OptionsBox = ({
  messagesLength = 0,
  subject,
  staticImageData,
  customSize,
  isLastBot,
  isUserMsg,
  position,
  mascotSettings,
  fromAMA = false,
  isMessage = false,
  available_tourTypes = [],
  messagesContainerRef = null,
  type = null,
}) => {
  const dispatch = useDispatch();
  const replies = useSelector(selectReplies);
  const messages = useSelector(selectMessages);
  const orgId = useSelector(getOrgId);
  const apiKey = useSelector(selectAPIKey);
  const entryId = useSelector(getEntryId);
  const enabledScheduleTour = useSelector(getEnabledScheduleTour);
  const optionsTypeLogs = useSelector(selectOptionsTypeLogs);
  const SSID = useSelector(getAppSSID);
  const prevLabel = useSelector(selectLabelItems);
  const propertyId = useSelector(selectPropertyId);
  const conversationID = useSelector(getConversationID);
  const isJAI = useSelector(selectIsJAI);
  const labelItems = useSelector(selectLabelItems);
  const isVideoTourEnabled = useSelector(getVisibleLiveVideoTour);
  const isInPersonTourEnabled = useSelector(getVisibleInPersonTour);
  const isSelfGuidedTourEnabled = useSelector(getVisibleSelfGuidedTour);
  const isMaximized = useSelector(getIsMaximized);
  const ifPhotosExist = useSelector(getVisiblePhotos);
  const ifCommunityInfoExist = useSelector(getVisibleCommunityInfo);
  const ifVideosExist = useSelector(getVisibleVideos);
  const isOptionDisabled = useSelector(selectIsDisabled);
  const amaReply = useSelector(getAMAReply);
  const paramObj = { ...prevLabel };

  const [isRepliesDisabled, setIsRepliesDisabled] = useState(isOptionDisabled);

  useEffect(() => {
    if (replies.optionsType === "FAQs") {
      dispatch(updateFaq(true));
    }

    if (replies.options?.length === 0 && (subject === "photos" || subject === "videos")) {
      dispatch(updateFaq(true));
    }
  }, [replies, subject]);

  const getSubjectAction = (subject, context) => {
    if (
      ALL_CHAT_SUBJECTS.filter(
        (subject) => subject !== "contact us" && subject !== "schedule" && subject !== "positive feedback" && subject !== "negative feedback"
      ).includes(subject)
    ) {
      if (isFirstCall()) {
        onClick([], optionsBySubject[subject], false, undefined, null, true, context);
        dispatch(setAMAReply(null));
      }
    }
  };

  useEffect(() => {
    if (type === "follow") {
      if (subject) {
        getSubjectAction(subject);
      }
    } else {
      if (amaReply && amaReply?.subject !== "others") {
        getSubjectAction(amaReply.subject, amaReply.context);
      }
    }
  }, [amaReply, type]);

  const onClick = (
    messages,
    nextOptionsType,
    disablePlaceholderMessage,
    callbackOptions,
    data = null,
    isAMA,
    context,
    customBtnText,
    customBtnLabel,
    customBtnId,
    isAsap
  ) => {
    // const { currentTourAction, currentBooking, currentRequiredInfo, currentSubject, currentNeedInfo } = getLocalStorageContextDetails(propertyId);

    // const isRescheduleInquiry =
    //   currentSubject === "schedule_a_tour" &&
    //   currentBooking &&
    //   !currentRequiredInfo &&
    //   (currentTourAction === "reschedule_inquiry" || currentTourAction === "status_inquiry");
    // const isScheduleInquiry = currentSubject === "schedule_a_tour" && SCHEDULE_TOUR_INQUIRIES.includes(currentTourAction);
    // const isMlContactForm = currentNeedInfo === "entryId";

    // const isMlForm = isRescheduleInquiry || isScheduleInquiry || isMlContactForm;

    if (!isAMA && (messages || nextOptionsType === "customButton") && nextOptionsType !== "Init") {
      const conversationId = conversationID || "";

      const textToSend = nextOptionsType === "customButton" ? customBtnLabel : t(messages?.[0]?.message) || "";

      const kgNodeValue = nextOptionsType === "customButton" ? customBtnLabel : t(messages?.[0]?.message) || "";

      createHayleyMessage({
        conversationId,
        propertyId,
        text: textToSend,
        queryType: "question",
        ownerType: "prospect",
        appName: "HayleyChat",
        kgNodes: [{ l0_subject: getSubjectFromNextOptionType(nextOptionsType, kgNodeValue) }],
      }).then((res) => res.json());
      // .then((data) => console.log("Hayley message created:", data));
    }

    if (nextOptionsType === "BedroomTypes" && messages?.[0]?.message === "findHome") {
      dispatch(setLabelItems({}));
      localStorage.removeItem(`${propertyId}-context`);
    }

    if (nextOptionsType === "PostContactUs") {
      setIsRepliesDisabled(true);
    }

    let duplicate_messages = [];

    messages?.forEach((msg) => {
      let message = {
        ...msg,
        createdAt: new Date(),
      };
      duplicate_messages.push(message);
    });

    // if (amaReply.description) {
    //   let desc = { message: amaReply.description, speaker: "bot", createdAt: new Date() };
    //   duplicate_messages.push(desc);
    // }
    if (nextOptionsType == "Init") {
      formatMessageEdit("Init");

      return;
    }

    if (nextOptionsType === "FAQs") {
      dispatch(setPagination());
    }

    if (defaultEditFormats.includes(nextOptionsType)) {
      dispatch(filterEditMessages([]));
    }

    dispatch(addNewMessage(duplicate_messages));

    if (callbackOptions) {
      const { data, triggerType } = callbackOptions;

      switch (triggerType) {
        case "SAVE_2_LOCAL_STORAGE":
          paramObj[data.name] = data.data;
          dispatch(setLabelItems(paramObj));
          break;

        default:
          break;
      }
    }

    if (nextOptionsType) {
      if (!disablePlaceholderMessage) {
        if (duplicate_messages.length === 1 && duplicate_messages[0].message === "Ask Me Anything" && duplicate_messages[0].key === "faqs") {
          //todo: update after release
        } else if (!amaReply) {
          setTimeout(() => {
            const message = optionTypes[nextOptionsType] || `typing`;
            dispatch(addNewMessage([{ message: message, speaker: "bot", createdAt: new Date().toISOString() }]));
          }, 300);
        }
      }

      dispatch(setIsDisabled(true));

      const keys = Object.keys(initialKeyOptions || {}).map((v, i) => v);

      if (keys.includes(nextOptionsType) && !isJAI && !["guest card", "scheduled tour"].includes(initialKeyOptions[nextOptionsType])) {
        createItemRecord(propertyId, SSID, initialKeyOptions[nextOptionsType]);
      }

      if (["LikeTour", "DisLikeTour", "SkipTour", "LikeContact", "DisLikeContact", "SkipContact"].includes(nextOptionsType)) {
        saveConversationFeedback(conversationID, data, feedbackKeyOptions[nextOptionsType]);
        dispatch(filterEditMessages([]));
      }

      const handleNextOptionSuccess = (res) => {
        let initialContext = res?.context || context;
        let responseMsg = amaReply?.description;

        if (res?.data?.floor_plans && !["UnitsAll", "UnitsByRoom", "Units"].includes(nextOptionsType)) {
          nextOptionsType = "UnitsAll";
        }

        if (["cancelTour", "noDoNotCancel"].includes(nextOptionsType)) {
          if (res?.data?.subject === "end of chat") {
            nextOptionsType = "end of chat";
            initialContext = res?.data?.context || [];
            responseMsg = res?.data?.response;
          } else {
            nextOptionsType = "ScheduleTour";
            initialContext = res?.data?.context || [];
            responseMsg = res?.data?.response?.description;
          }
        }

        const agentHandOff = res?.data?.agent_handoff ?? {};

        // (res.data?.subject === "schedule a tour" || res.data?.subject === "hands_off")

        if (res?.data?.context || (agentHandOff && Object.keys(agentHandOff).length > 0 && nextOptionsType === "postContactUs")) {
          if (
            (nextOptionsType === "PostContactUs" || nextOptionsType === "PostScheduleTour") &&
            ((res.data?.subject === "schedule a tour" && res.data?.context?.length > 0) || res.data?.agent_handoff?.agent_handoff_triggered)
          ) {
            const resSubject = res?.data?.subject;
            const resContext = res?.data?.context?.[0];

            const availableSlots = res?.data?.response?.available_slots || res?.data?.response?.booking?.available_slots || [];

            if (resSubject === "schedule a tour") {
              if (availableSlots && Array.isArray(availableSlots) && availableSlots.length > 0) {
                const tourType =
                  resContext?.tourType || APPOINTMENT_TYPES[res?.data?.response?.booking?.booking?.appointmentType] || labelItems.appointment_type;

                const tourOptions = {
                  in_person_tour: isInPersonTourEnabled,
                  live_video_tour: isVideoTourEnabled,
                  self_guided_tour: isSelfGuidedTourEnabled,
                };

                setTimeout(() => {
                  for (const [appointmentType, isEnabled] of Object.entries(tourOptions)) {
                    if (isEnabled) {
                      handleTourResponse(res, false, tourType || appointmentType);
                      break;
                    }
                  }
                }, 0);

                dispatch(setShouldFetchSlots(false));
              }

              const bookingDetails = res?.data?.response?.booking?.booking ?? {};

              if (resContext?.booking_found && !resContext?.required_info) {
                if (bookingDetails && Object.keys(bookingDetails).length > 0) {
                  localStorage.setItem(`${propertyId}-booking_details`, JSON.stringify(bookingDetails));
                }
              }

              dispatch(setTourAction(resContext?.tourAction));
            }

            const linksHandle = resSubject === "schedule a tour" || resSubject === "unit availability" ? res.data.response?.description : res.data.response;

            const agentHandoff = res?.data?.agent_handoff ?? {};

            const isAgentHandoff = agentHandoff?.agent_handoff_triggered;

            if (optionsBySubject[resSubject]) {
              dispatch(
                setAMAReply({
                  description: res.data.response?.description ?? null,
                  message: linksHandle,
                  id: res.data.message_id,
                  summary: res.data.neighborhood_summary,
                  neighborhood: res.data.context?.[0] ?? {},
                  speaker: "faqBot",
                  subject: resSubject,
                  context: res.data.context,
                  createdAt: new Date(),
                  available_tourTypes: res.data?.available_tourTypes,
                  not_available: res.data.response?.available_slots?.filter_excluded,
                  follow_up: res.data?.follow_up,
                  availableUnits: null,
                  images: [],
                  photos: [],
                })
              );
            } else if (isAgentHandoff) {
              if (agentHandoff?.need_info === "entry_id") {
                localStorage.setItem(`${propertyId}-agentHandOff`, JSON.stringify(agentHandoff));

                dispatch(setIsDisabled(false));

                dispatch(
                  removeAndAddMessages([
                    {
                      message: t("leasing_agent_will_contact"),
                      speaker: "bot",
                      createdAt: new Date().toISOString(),
                    },
                  ])
                );

                let rep = {
                  checkStorage: true,
                  disableResetBox: false,
                  options: FORM_4_CONTACT_US_OPTIONS,
                  optionsType: "Form4ContactUs",
                  title: "Enter First Name and Last Name",
                  renderType: "multiInputView",
                };

                dispatch(setReplies(rep));
              } else {
                dispatch(
                  removeAndAddMessages([
                    {
                      message: res?.data?.response || "Leasing agent will contact you soon...",
                      id: res.data.message_id,
                      speaker: "faqBot",
                      createdAt: new Date(),
                    },
                  ])
                );

                dispatch(setReplies(INITIAL_REPLIES));
                dispatch(setIsDisabled(false));

                localStorage.removeItem(`${propertyId}-agentHandOff`);
              }
            }

            return;
          }
        }

        if (amaReply?.subject === "embed_map_view") {
          responseMsg = amaReply.message;
        }

        const { nextReplies, nextBotMessages } = makeNextOptions(
          nextOptionsType,
          res.data,
          res.extraData || undefined,
          isAMA,
          res.skip,
          initialContext,
          amaReply?.not_available,
          responseMsg
        );

        if (nextReplies.options.length > 1 || nextOptionsType === "DoIQualify") {
          dispatch(updateFaq(false));
        } else {
          if (nextOptionsType === "Cancel") {
            dispatch(updateFaq(true));
          }
        }

        let duplicateMessages = nextBotMessages || [];
        let newMessages = [];

        duplicateMessages?.forEach((msg) => {
          let message = { ...msg, createdAt: new Date() };
          newMessages.push(message);
        });

        if (["unitView"].includes(nextReplies?.renderType)) {
          newMessages.push({ key: compMsgKeys[nextReplies?.renderType] || nextReplies?.renderType, speaker: "comp", replies: nextReplies });
        }

        if (!disablePlaceholderMessage && !res?.amaApi) {
          if (duplicate_messages.length === 1 && duplicate_messages[0].message === "Ask Me Anything" && duplicate_messages[0].key === "faqs") {
            //todo: update after release
          } else {
            setTimeout(() => {
              dispatch(removeAndAddMessages(newMessages));
            }, 300);
          }
        } else {
          dispatch(addNewMessage(newMessages));
        }

        if (nextOptionsType === "Photos") {
          const checkPhotos = duplicateMessages?.find((v) => v.message === "noPhotoWhatNext");

          if (!ifPhotosExist || checkPhotos) {
            setTimeout(() => {
              let temp = nextReplies;
              temp.options.push(EXPLORE_MORE_OPTION);
              dispatch(setReplies(temp));
              dispatch(setIsDisabled(false));
            }, 300);

            dispatch(addNewMessage([]));

            return;
          }
        }

        if (nextOptionsType === "customButton") {
          let temp = nextReplies;
          temp.customBtnText = customBtnText;

          if (customBtnText && customBtnLabel) {
            newMessages.push(
              { message: customBtnLabel, key: "text", optionsType: "Init", speaker: "user", createdAt: new Date().toISOString() },
              { message: "hereCustomBtnDetails", key: "text", speaker: "bot", createdAt: new Date().toISOString() },
              { message: customBtnText, key: "text", speaker: "comp", createdAt: new Date().toISOString() }
            );
          } else {
            dispatch(setReplies(temp));
          }
        }

        if (nextOptionsType === "Videos") {
          const checkVideo = duplicateMessages?.find((v) => v.message === "noVideoWhatNext");

          if (!ifVideosExist || checkVideo) {
            setTimeout(() => {
              let temp = nextReplies;
              temp.options.push(EXPLORE_MORE_OPTION);
              dispatch(setReplies(temp));
              dispatch(setIsDisabled(false));
            }, 300);

            dispatch(addNewMessage([]));

            return;
          }
        }

        if (nextOptionsType === "CommunityInfo") {
          const checkCommunityInfo = duplicateMessages?.find((v) => v.message === "noCommunityInfoWhatNext");

          if (!ifCommunityInfoExist || checkCommunityInfo) {
            setTimeout(() => {
              let temp = nextReplies;
              temp.options.push(EXPLORE_MORE_OPTION);
              dispatch(setReplies(temp));
              dispatch(setIsDisabled(false));
            }, 300);

            dispatch(addNewMessage([]));

            return;
          }
        }

        setTimeout(() => {
          dispatch(setReplies(nextReplies));
          dispatch(setIsDisabled(false));
          setIsRepliesDisabled(false);
        }, 300);

        if (nextOptionsType !== replies.optionsType) {
          dispatch(setOptionsTypeLogs([...optionsTypeLogs, replies.optionsType]));
        }

        if (!isAMA && (newMessages || nextOptionsType === "customButton")) {
          const conversationId = conversationID || "";

          const isCustom = nextOptionsType === "customButton";

          const textToSend = t(newMessages?.[isCustom ? 1 : 0]?.message) || "";

          createHayleyMessage({
            conversationId,
            propertyId,
            text: textToSend,
            queryType: "answer",
            ownerType: "agent",
            appName: "HayleyChat",
            kgNodes: [],
          }).then((res) => res.json());
          // .then((data) => console.log("Hayley message created:", data));
        }

        if (["Photos", "Videos", "CommunityInfo"].includes(nextOptionsType)) {
          if (nextReplies.options.length) {
            const { nextOptionsType: type, data: getData } = nextReplies.options[0];

            getNextOptions(type, getData, null, null, null, null, null, amaReply?.photos).then((res) => {
              const { nextReplies } = makeNextOptions(type, res.data, res.extraData || undefined);

              setTimeout(() => {
                dispatch(
                  addNewMessage([
                    {
                      key: compMsgKeys[nextReplies?.renderType] || replies?.renderType,
                      speaker: "comp",
                      createdAt: new Date(),
                      message: amaReply?.message,
                      images: res?.data,
                    },
                  ])
                );

                dispatch(setIsDisabled(false));
              }, 400);

              dispatch(setReplies(nextReplies));
            });
          }
        }
      };

      if (amaReply?.availableUnits) {
        let res = {
          data: amaReply?.availableUnits,
          extraData: {
            enableExtraOption: false,
          },
          skip: undefined,
          amaApi: true,
          context: amaReply?.context,
        };

        const myMsg = [];

        dispatch(removeAndAddMessages(myMsg));
        handleNextOptionSuccess(res);

        return;
      }

      if (!amaReply?.availableUnits && amaReply?.subject === "unit availability") {
        dispatch(
          removeAndAddMessages([
            {
              message: amaReply?.description || "Cannot find any matching units.",
              speaker: "bot",
              createdAt: new Date().toISOString(),
            },
          ])
        );

        dispatch(setReplies(INITIAL_REPLIES));

        dispatch(setIsDisabled(false));

        return;
      }

      if (context) {
        if (context.length > 0 && context?.[0]?.need_info === "entryId" && nextOptionsType === "ScheduleTour") {
          nextOptionsType = "Form4ContactUs";
        }
      }

      getNextOptions(nextOptionsType, data, isAMA, context, available_tourTypes, customBtnId, isAsap, amaReply?.photos)
        .then((res) => {
          handleNextOptionSuccess(res);
        })
        .catch(async (err) => {
          setIsRepliesDisabled(false);
          dispatch(addNewMessage([{ message: ERROR_MSG, speaker: "bot", subject: "", createdAt: new Date() }]));

          dispatch(setIsDisabled(false));

          setTimeout(() => {
            dispatch(removeLoadingMsgs());
          }, 100);
        });

      // .finally(() => {
      //   setTimeout(() => {
      //     dispatch(setIsDisabled(false));
      //   }, 300);
      // });
    }
  };

  const isBoxView = ["boxView"].includes(replies.renderType);

  const isMultiView = !isBoxView || ["AvailableTimes"].includes(replies?.optionsType);

  const onRestart = (mode) => {
    const { currentTourAction, currentBooking, currentRequiredInfo, currentSubject } = getLocalStorageContextDetails(propertyId);

    const isRescheduleInquiry =
      currentSubject === "schedule_a_tour" &&
      currentBooking &&
      !currentRequiredInfo &&
      (currentTourAction === "reschedule_inquiry" || currentTourAction === "status_inquiry");
    const isScheduleInquiry = currentSubject === "schedule_a_tour" && SCHEDULE_TOUR_INQUIRIES.includes(currentTourAction);

    const history = getLastConversations(messages, 5)
      ?.map((i) => ({
        role: i.speaker == "bot" || i.speaker == "faqBot" ? "assistant" : "user",
        content: i.message,
      }))
      .filter((i) => i.content && i.content.trim() !== "");

    const faqReply = {
      history,
      propertyId,
      orgId: orgId,
      message: "Cancel",
      conversation_id: conversationID || "",
      session_id: SSID || DEFAULT_SESSION_ID,
      graphql_api_key: encodeURIComponent(apiKey),
      tourScheduleEnabled: enabledScheduleTour,
      entry_id: String(entryId ?? ""),
    };

    const isTriggerMLOnCancel = isRescheduleInquiry || isScheduleInquiry;

    if (isTriggerMLOnCancel) {
      getFAQsReply(faqReply)
        .then((res) => {})
        .catch((err) => {
          console.error("getFAQsReply error:", err);
        });
    }

    dispatch(addNewMessage([{ message: "cancel", speaker: "user", createdAt: new Date().toISOString() }]));

    if (!isTriggerMLOnCancel) {
      createHayleyMessage({
        conversationId: conversationID || "",
        propertyId,
        text: "Cancel",
        queryType: "question",
        ownerType: "prospect",
        appName: "HayleyChat",
        kgNodes: [{ l0_subject: mode ? CANCEL_FORM_KEYS[mode] : "Cancel" }],
      }).then((res) => res.json());
    }

    formatMessageEdit("Init", null, !isTriggerMLOnCancel ? "formCancel" : "");

    dispatch(updateFaq(false));
    dispatch(resetLabelItems());
    dispatch(resetScheduleTourState());

    localStorage.removeItem(`${propertyId}-context`);
    localStorage.removeItem(`${propertyId}-agentHandOff`);
  };

  return fromAMA ? (
    <BoxView
      replies={replies}
      onClick={onClick}
      staticImageData={staticImageData}
      customSize={customSize}
      isLastBot={isLastBot}
      isUserMsg={isUserMsg}
      position={position}
      mascotSettings={mascotSettings}
      fromAMA={fromAMA}
    />
  ) : isOptionDisabled || replies.optionsType === "FAQs" || isRepliesDisabled ? null : (
    <>
      <div
        className={`${
          (((isBoxView && !isMaximized) || (isMaximized && isMultiView) || messagesLength === 1) && replies.optionsType === "customButton") ||
          (replies.optionsType === "Form4ScheduleTour" && !isMaximized)
            ? ""
            : `hayley-block ${!isMessage ? "hayley-pl-12" : "hayley-pl-4"} `
        }`}
      >
        {replies?.optionLabel && messagesLength === 1 ? (
          <div className={`hayley-mb-3 hayley-bg-custom-1 hayley-font-sans hayley-text-sm hayley-font-semibold hayley-text-custom-4`}>
            {t(replies?.optionLabel)}
          </div>
        ) : null}
        {replies.renderType === "boxView" && (
          <BoxView
            replies={replies}
            onClick={onClick}
            staticImageData={staticImageData}
            customSize={customSize}
            isLastBot={isLastBot}
            isUserMsg={isUserMsg}
            position={position}
            mascotSettings={mascotSettings}
            fromAMA={fromAMA}
          />
        )}

        {replies.renderType === "inputView" && <InputView replies={replies} onClick={onClick} />}

        {replies.renderType === "multiInputView" && (
          <MultiInputView messagesContainerRef={messagesContainerRef} replies={replies} onClick={onClick} onCancel={onRestart} />
        )}
      </div>
    </>
  );
};

export default OptionsBox;
